import { UserService } from './../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { SuperService } from './../services/super.service';
import { AppState } from '../state/app.reducer';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromComplaintsSelector from '../../pages/home/state/complaints.selectors';
import * as fromComplaintsActions from '../../pages/home/state/complaints.actions';

import * as fromUserSelector from '../../pages/user/state/user.selectors';
import * as fromUserActions from '../../pages/user/state/user.actions';

@Injectable({
	providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
	constructor(
		private store: Store<AppState>,
		public auth: AuthService,
		public router: Router,
		private superService: SuperService,
		private toastr: ToastrService,
		private userService: UserService
	) {}

	canActivate(): Observable<boolean> | boolean {
		const token = localStorage.getItem('idToken'); // If have token, user are logged

		if (!token) {
			this.router.navigate(['/auth']);
			return false;
		} else {
			const su = Boolean(localStorage.getItem('superUser'));

			this.checkTime(su);

			this.store.select(fromUserSelector.selectUser).subscribe((user) => {
				if (!user) {
					this.store.dispatch(fromUserActions.doLoadUser());
				}
			});

			this.store.select(fromUserSelector.selectUser).subscribe((user) => {
				if (!user) {
					if (su) {
						this.store.dispatch(fromUserActions.doLoadUsersSuper());
					} else {
						this.store.dispatch(fromUserActions.doLoadUsersStandard());
					}
				}
			});

			this.store
				.select(fromComplaintsSelector.selectBusLines)
				.subscribe((busLines) => {
					if (!busLines.length) {
						this.store.dispatch(fromComplaintsActions.loadBusLines());
					}
				});

			this.store
				.select(fromComplaintsSelector.selectComplaintsPerPeriod)
				.subscribe((complaints) => {
					if (complaints.length === 0) {
						this.store.dispatch(
							fromComplaintsActions.loadComplaintsPerPeriod()
						);
					}
				});

			let complaintsCounter = 0;

			this.store
				.select(fromComplaintsSelector.selectComplaintsEntities)
				.subscribe((complaints) => {
					if (complaints.length == 0 && complaintsCounter == 0) {
						complaintsCounter = 1;
						this.store.dispatch(fromComplaintsActions.loadComplaints());
					}
				});

			return true;
		}
	}

	checkTime(su: boolean): void {
		const accessHour = new Date(localStorage.getItem('accessHour'));
		// if 1 hour till access, refresh token

		if (new Date().getTime() - accessHour.getTime() >= 1000 * 60 * 55) {
			let service;
			if (su) {
				service = this.superService;
			} else {
				service = this.userService;
			}

			service.refreshToken().subscribe(
				(data) => {
					this.auth.setCredentials(
						data.AuthenticationResult.AccessToken,
						data.AuthenticationResult.IdToken
					);
					this.toastr.success('Token atualizado com sucesso.');
				},
				(error) => {
					this.toastr.error(
						'Não conseguimos atualizar seu Token. Faça o Login novamente.'
					);
					this.auth.logout();
				}
			);
		}
	}
}
